import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import DialogContentText from "@mui/material/DialogContentText";
import Tools from "./JNSTools";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import { Visibility } from "@mui/icons-material";
import { VisibilityOff } from "@mui/icons-material";
import { CredsContext } from "./Contexts";
import CustomAlert from "./CustomAlert";
import "./styles/MainToolbar.css";

function SettingsEditPassword() {
  const creds = useContext(CredsContext).creds;
  const setCreds = useContext(CredsContext).setCreds;
  const [boxDisabled, setBoxDisabled] = useState(true);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  let inputRef;

  const handleClick = () => {
    if (!boxDisabled) {
      setOpenConfirmation(true);

      const authString = Tools.getXmlBodyAuthString(creds);
      const urlString = Tools.getInstanceUrl(creds);

      let requestString =
        authString +
        '<Modify type="User" enable_custom="1"><User><id>' +
        creds.id +
        "</id>";

      if (creds.userType == "generic") {
        requestString +=
          "<oada_password__c>" +
          inputRef.children[0].value +
          "</oada_password__c>";
      } else {
        requestString +=
          "<password>" + inputRef.children[0].value + "</password>";
      }
      requestString += "</User></Modify></request>";
      Tools.fetchPost(requestString, urlString);
      creds.password = inputRef.children[0].value;
      setCreds({ ...creds, password: inputRef.children[0].value });
    }
    setBoxDisabled(!boxDisabled);
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <DialogContentText id="alert-dialog-description" sx={{ color: "white" }}>
        Password:
      </DialogContentText>
      <Box display="flex">
        <Input
          ref={(i) => (inputRef = i)}
          type={showPassword ? "text" : "password"}
          defaultValue={creds.password}
          className="settingsTextField"
          size="small"
          disabled={boxDisabled}
          endAdornment={
            <InputAdornment
              position="end"
              sx={{
                height: "19px",
                backgroundColor: "white",
                margin: "0px",
                padding: "1px 3px",
              }}
            >
              <IconButton
                size="small"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        ></Input>
        <Button
          variant="contained"
          onClick={handleClick}
          sx={{
            height: "80%",
            width: "80px",
            border: "solid 1px",
            backgroundColor: "darkslategray",
            borderRadius: "10px",
            marginBottom: "3px",
            marginTop: "7px",
            marginLeft: "10px",
          }}
        >
          {boxDisabled ? <>Edit</> : <>Save</>}
        </Button>
      </Box>
      <CustomAlert
        alertText="Password reset"
        openAlert={openConfirmation}
        setOpenAlert={setOpenConfirmation}
      />
    </>
  );
}

export default SettingsEditPassword;

SettingsEditPassword.propTypes = {
  handleSettingsChange: PropTypes.func,
};
